/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';

export const FORM_OPTION_GROUP_TYPE_PANEL = "panel";
export const FORM_OPTION_GROUP_TYPE_TAB = "tab";

export const DEFAULT_GROUP_DEPTH = "0";

export const GROUP_DEPTHS = {
    [DEFAULT_GROUP_DEPTH]: {
        name: "0",
        level: 0,
    },
    "1": {
        name: "1",
        level: 1,
    },
    "2": {
        name: "2",
        level: 2,
    },
};

export default declareLinkedEntity({
    entity: "flowOptionGroupDefs",
    graphQL: "FlowOptionGroupDef",
    name: "Flow Option Group Definition",
    defaultOrder: ['order', 'name'],
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    dynamoPrefix: 'def',
    storageType: 'schema',
    parentRelation: 'flowOptionGroupDefs',
    defaultTitle: (data) => {
        return data['name'];
    },
    onModify: ['flowDef'],
    fields: (types) => { return {
        id: {
            name: "Flow Option Group Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            compositeKey: true,
            userEditable: false,
        },
        flowDef: {
            name: "Flow Definition",
            type: "relation",
            to: () => types['flowDefs'],
            defaultValue: (flowDef) => {
                return flowDef['id'];
            },
            required: true,
            parent: true,
            compositeKey: true,
            hiddenCreate: true,
            relativeTo: ["flowDefVersion"],
        },
        flowDefVersion: {
            name: "Flow Definition Version",
            to: () => types['flowDefVersions'],
            type: "relation",
            defaultValue: (flow) => {
                return flow['flowDefVersion_id'];
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        order: {
            name: "Order",
            type: "int",
            defaultValue: "0",
        },
        name: {
            name: "Name",
            type: "string",
            trim: true,
            translatable: true,
            defaultValue: "",
            required: true,
        },
        description: {
            name: "Description",
            type: "html",
            translatable: true,
            defaultValue: ""
        },
        longDescription: {
            name: "Long Description",
            type: "html",
            translatable: true,
            defaultValue: ""
        },
        collapsed: {
            name: "Collapsed",
            type: "boolean",
            defaultValue: false,
            visibility: (data) => data['type'] !== FORM_OPTION_GROUP_TYPE_TAB,
        },
        depthlevel: {
            name: "Depth",
            type: "enum",
            defaultValue: DEFAULT_GROUP_DEPTH,
            values: GROUP_DEPTHS,
        },
        type: {
            name: "Type",
            type: "enum",
            defaultValue: FORM_OPTION_GROUP_TYPE_PANEL,
            values: {
                [FORM_OPTION_GROUP_TYPE_PANEL]: {
                    name: "Panel",
                },
                [FORM_OPTION_GROUP_TYPE_TAB]: {
                    name: "Tab",
                },
            }
        },
        visibilityJS: {
            name: "Visibility JS",
            type: "javascript",
            defaultValue: "",
            globalVariables: {
                'getValue': 'getValue(field: string)',
                'hasChannelDef': 'hasChannelDef(keyOrChannelDefId: string, alias: string, noExtended?: boolean)',
            },
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
});
